//import Libraries
import React from 'react';
import PropTypes from 'prop-types';

//import Components

//import Style classes
import './HiddenContent.css';

const normalType = (props)=>{

    return(
        <div className={"HiddenContent NormalType"}>
            <div className="DummySection">
            </div>
            <div className="NormalTypeContent Content">
                <h3>{props.data.name[props.lang]}</h3>
                <p>{props.data.content[props.lang]}</p>
            </div>
        </div>
    )
}

export default normalType;

normalType.propTypes = {
    data: PropTypes.object.isRequired
  };



// WEBPACK FOOTER //
// ./src/components/DepartmentModule/Contents/ContentCard/HiddenContent/NormalType.js